<template>
    <div class="relative" v-click-outside="onClickOutside">
        <span class="cursor-pointer" v-on:click="menuopen = !menuopen">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"
                class="w-5 h-5 stroke-current text-gray-500 hover:text-navy-dark"
                :class="{ 'text-navy-dark' : menuopen, 'text-gray-500' : !menuopen}">
                <g>
                    <circle cx="7" cy="2" r="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"></circle>
                    <circle cx="7" cy="7" r="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"></circle>
                    <circle cx="7" cy="12" r="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"></circle>
                </g>
            </svg>
        </span>
        <div v-if="menuopen" class="absolute w-32 top-4 right-0 z-50 p-2 bg-white rounded shadow-md border">
            <div v-for="(link, title) in links" :key="title"
                class="py-1 px-2 text-xs text-gray-700 text-left font-medium hover:bg-gray-300 hover:text-gray-800">
                <inertia-link :href="link" class="block">
                    {{title}}
                </inertia-link>
            </div>
        </div>
    </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3';
export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    props : {
        links: Object
    },
    data() {
        return {
            menuopen: false
        }
    },
    methods: {
        onClickOutside (event) {
            this.menuopen = false;
        }
    }
}
</script>
